<template>
  <div class="orient-box" id="orient-box"> 
    <img class="title" src="https://ambow-ebopo.oss-cn-beijing.aliyuncs.com/words/images/pic/m/1598332580333110.png" alt="">
    <div class="orient-class">
      <img @click="goDetail" src="https://ambow-ebopo.oss-cn-beijing.aliyuncs.com/words/images/pic/m/159833264989693.png" alt="">
      <img src="https://ambow-ebopo.oss-cn-beijing.aliyuncs.com/words/images/pic/m/1598332672014105.png" alt="">
      <img src="https://ambow-ebopo.oss-cn-beijing.aliyuncs.com/words/images/pic/m/1598332682253124.png" alt="">
      <img src="https://ambow-ebopo.oss-cn-beijing.aliyuncs.com/words/images/pic/m/159833269280267.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{

    }
  },
  methods:{
    goDetail(){
      this.$router.push("/orient/detail")
    }
  }
}
</script>
<style lang="less" scoped>
.orient-box{
  width:100%;
  display:flex;
  flex-direction:column;
  align-items: center;
  justify-content: center;
  .title{
    width:474px;
    height: 51px;
    margin: 30px 0;
  }
  .orient-class{
    width:100%;
    display:flex;
    justify-content: space-between;
    img{
      width:280px;
      height: 310px;
      cursor: pointer;
    }
  }
}
</style>